import { KYDEventMetrics } from "@common/interfaces/KYDEvent";
import { useEffect, useState } from "react";
import { useDialog } from "../../../Common/Dialog";
import { useLoading } from "../../hooks/form";
import actions from "../../../actions";

export const useEventMetrics = (event_id: string) => {
  const [metrics, setMetrics] = useState<KYDEventMetrics | null>(null);
  const [loading, updateLoading] = useLoading<{ metrics: boolean }>({
    metrics: false,
  });
  const dialog = useDialog();

  useEffect(() => {
    const fetchMetrics = async (event_id) => {
      updateLoading("metrics", true);

      try {
        const _ = await actions.ADMIN.fetchEventMetrics(event_id);
        setMetrics(_);
      } catch (err) {
        dialog({ text: err.message });
      }

      updateLoading("metrics", false);
    };

    if (event_id) {
      fetchMetrics(event_id);
    }
  }, [event_id, updateLoading, dialog]);

  return {
    metrics,
    loading: loading.metrics,
  };
};
